import React from "react";

import { AuthProvider } from "./useAuth";
import { DownloadArchiveProvider } from "./useDownloadArchive";

const AppProvider: React.FC = ({ children }) => (
  <AuthProvider>
    <DownloadArchiveProvider>{children}</DownloadArchiveProvider>
  </AuthProvider>
);

export default AppProvider;
